<template>
  <Timeline>
    <TimelineItem :color="item.color" v-for="item in logs_own" :key="item.id">
      <p class="time"><b>{{ moment(item.created_at).format('YYYY-MM-DD HH:mm:ss') }}</b></p>
      <p class="">{{ item.content }}</p>
    </TimelineItem>
  </Timeline>
</template>
<script>
import moment from 'moment'
export default {
  name: 'FlowLogs',
  props: ['logs'],
  data () {
    return {
      moment: moment,
      logs_own: this.logs
    }
  },
  watch: {
    logs () {
      let logsTmp = []
      this.logs.map((item, index) => {
        if (item.type === 'error') {
          item['color'] = 'red'
        } else if (item.type === 'info') {
          item['color'] = 'blue'
        } else {
          item['color'] = 'green'
        }
        logsTmp.push(item)
      })
      this.logs_own = logsTmp
    }
  },
  methods: {
  },
  mounted: function () {
  }
}
</script>

<style scoped>

</style>
